<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h1 class="text-h3 mb-4">Настройка источников</h1>
        <v-card>
          <v-card-text>
            <p class="text-body-1">Страница настройки источников данных (только для администраторов)</p>
            <!-- TODO: Add source configuration forms and settings -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SourceConfiguration'
};
</script>